<div class="data-insight-panel"
     [ngClass]="{'tiled': tiled, 'untiled': !tiled}">

    <p-panel>

        <ng-template pTemplate="header">

            <div class="panel-header">

                <h6 class="p-panel-title">
                    <i aria-hidden="true" [ngClass]="icon"></i>
                    &nbsp;
                    {{ title }}
                </h6>
            </div>

        </ng-template>

        <div class="columns">

            <div class="column1 primary">

                <p class="end">
                    <span title="At End">{{ (totals.end | count) || 0 }}</span>
                </p>
            </div>

            <div class="column2 secondary">

                <p class="start">
                    At Start:
                    {{ (totals.start | count) || 0 }}
                </p>
                <p class="delta"
                   [ngClass]="{
                              'opposite': lessIsMore,
                              'negative': negativeDifference(totals.end, totals.start),
                              'neutral': noDifference(totals.end, totals.start),
                              'positive': positiveDifference(totals.end, totals.start),
                              }">
                    Change:
                    {{ (totals.end | deltaSymbol: totals.start) }}{{ (totals.end | delta: totals.start | absolute) || 0 }}

                    <span class="indicator"
                          [ngClass]="{
                                     'opposite': lessIsMore,
                                     'negative': negativeDifference(totals.end, totals.start),
                                     'neutral': noDifference(totals.end, totals.start),
                                     'positive': positiveDifference(totals.end, totals.start),
                                     }"></span>
                </p>
            </div>

            <div #sparklines class="column3 sparklines" *ngIf="mappedChartData">

                <app-sparkline-chart [chartData]="mappedChartData"
                                     [chartContainer]="sparklines"></app-sparkline-chart>
            </div>
        </div>

    </p-panel>
</div>
